/**
 *  @class
 *  @function VideoControls
 */
if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.video = this.parentElement.querySelector('video');
      this.sound_toggle = this.querySelector('.video-controls--sound');
      this.play_toggle = this.querySelector('.video-controls--play-pause');

      this.setEventListeners();
    }
    setEventListeners() {
      this.play_toggle.addEventListener('click', this.playPause.bind(this));
      this.sound_toggle.addEventListener('click', this.muteUnmute.bind(this));
    }
    playPause(e) {
      if (this.video.paused) {
        this.video.play();
        this.play_toggle.classList.remove('paused');
      } else {
        this.video.pause();
        this.play_toggle.classList.add('paused');
      }
      e.stopPropagation();
    }
    muteUnmute(e) {
      if (this.video.muted) {
        this.video.muted = false;
        this.sound_toggle.classList.remove('muted');
      } else {
        this.video.muted = true;
        this.sound_toggle.classList.add('muted');
      }
      e.stopPropagation();
    }
  }
  customElements.define('video-controls', VideoControls);
}


/* Defer shoppable reel video sources until the section is close to view.
   The video controls and muted autoplay behavior remain available after insertion. */
(function () {
  function loadDeferredReelVideos(scope) {
    var sections = [];
    if (scope && scope.matches && scope.matches('.shoppable-video-reels')) {
      sections.push(scope);
    } else if (scope && scope.querySelectorAll) {
      sections = Array.prototype.slice.call(scope.querySelectorAll('.shoppable-video-reels'));
    }

    sections.forEach(function (section) {
      if (section.dataset.mfDeferredVideosObserved === 'true') return;
      var templates = section.querySelectorAll('template.shoppable-video-reels__deferred');
      if (!templates.length) return;
      section.dataset.mfDeferredVideosObserved = 'true';

      var observer = null;
      var load = function () {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
        templates.forEach(function (template) {
          if (template.isConnected) {
            template.replaceWith(template.content.cloneNode(true));
          }
        });
      };

      if (!('IntersectionObserver' in window)) {
        load();
        return;
      }

      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) load();
      }, { rootMargin: '600px 0px' });
      observer.observe(section);
      section._mfDeferredVideoObserver = observer;
    });
  }

  loadDeferredReelVideos(document);
  document.addEventListener('shopify:section:load', function (event) {
    loadDeferredReelVideos(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var sections = event.target.querySelectorAll ? event.target.querySelectorAll('.shoppable-video-reels') : [];
    sections.forEach(function (section) {
      if (section._mfDeferredVideoObserver) {
        section._mfDeferredVideoObserver.disconnect();
        delete section._mfDeferredVideoObserver;
      }
    });
  });
})();
